import type { PlatformSyncResult } from "@repo/shared/types";
import { toast } from "sonner";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./use-platform-sync-warnings.i18n";

/**
 * Translated toasts for what a platform change did to the goal's portfolios:
 * products the new platform excludes, and hand-picked model portfolios returned
 * to the matching one (QL-72). Shared by every place a platform sync result lands.
 */
export function usePlatformSyncWarnings() {
  const t = useT(T);

  return (sync: Partial<PlatformSyncResult> | undefined) => {
    if (sync?.removedProducts?.length) {
      toast.warning(`${t.productsRemovedWarning}${sync.removedProducts.join(", ")}`);
    }
    if (sync?.resetModelSelections?.length) {
      toast.warning(`${t.modelSelectionsResetWarning}${sync.resetModelSelections.join(", ")}`);
    }
  };
}
